import { MenuProps } from '@mui/material/Menu';

export const getBaseSelectWithCheckboxesMenuProps = (): Partial<MenuProps> => ({
  PaperProps: {
    sx: {
      maxHeight: 'calc(48*4.5px)',
      width: 200,
    },
  },
});
